module.exports = __webpack_public_path__ + "static/media/Futbol.d39f4a41.png";